// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2457":"0975a47c","5650":"9cdaa2e5","6203":"bba9dcc0"}[chunkId] + ".chunk.css";
};